import { Button } from "@earth-note/ui";
import { SETTINGS_URL } from "../utils/constants";
import type { AddinConfigDisabled } from "../types";

interface DisabledUserProps {
  config: AddinConfigDisabled;
}

function getContent(config: AddinConfigDisabled) {
  switch (config.reason) {
    case "user_inactive":
      return {
        icon: "🚫",
        title: "Account Deactivated",
        message: config.message,
        action: null,
      };
    case "subscription_inactive":
      return {
        icon: "⏸️",
        title: "Subscription Inactive",
        message: config.message,
        action: null,
      };
    case "account_disabled":
      return {
        icon: "⚙️",
        title: "Earth Note Disabled",
        message: config.message,
        action: {
          label: "Go to Settings",
          url: config.settingsUrl ?? SETTINGS_URL,
        },
      };
    default:
      return {
        icon: "⚠️",
        title: "Not Available",
        message: config.message,
        action: null,
      };
  }
}

export function DisabledUser({ config }: DisabledUserProps) {
  const content = getContent(config);

  return (
    <div className="flex h-full flex-col p-6">
      <div className="mb-6 flex justify-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-bg-weak-50">
          <span className="text-3xl">{content.icon}</span>
        </div>
      </div>

      <div className="mb-6 text-center">
        <h2 className="text-title-h6 mb-2 font-semibold text-text-strong-950">{content.title}</h2>
        <p className="text-paragraph-sm text-text-sub-600">{content.message}</p>
      </div>

      {content.action && (
        <div className="mt-auto">
          <a href={content.action.url} target="_blank" rel="noopener noreferrer">
            <Button.Root className="w-full">{content.action.label}</Button.Root>
          </a>
        </div>
      )}
    </div>
  );
}
